import { PAGES } from "@dune/types";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useCheckAuth } from "../api/queries/auth.queries";
import { getMe } from "../api/queries/users.queries";
import { useAuthStore } from "../stores/auth.store";
import { checkBrokerAccess } from "../utils/brokerAccessUtils";

export const PublicRoute = () => {
	const navigate = useNavigate();
	const accessToken = useAuthStore((state) => state.accessToken);
	const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
	const { data: authCheck, isLoading, isError } = useCheckAuth();

	useEffect(() => {
		const checkAndRedirect = async () => {
			if (!isLoading && !isError && authCheck && accessToken && isLoggedIn) {
				try {
					const user = await getMe();
					if (user.role === "BROKER") {
						const accessCheck = await checkBrokerAccess();
						navigate(accessCheck.redirectTo);
					} else {
						navigate(PAGES.ROOT);
					}
				} catch {
					navigate(PAGES.ROOT);
				}
			}
		};

		checkAndRedirect();
	}, [isLoading, isError, authCheck, accessToken, isLoggedIn, navigate]);

	if (isLoading) {
		return (
			<div className="flex items-center justify-center h-screen">
				<h1 className="text-3xl font-semibold">Vérification...</h1>
			</div>
		);
	}

	if (!isError && authCheck && accessToken && isLoggedIn) {
		return (
			<div className="flex items-center justify-center h-screen">
				<h1 className="text-3xl font-semibold">Redirection...</h1>
			</div>
		);
	}

	return <Outlet />;
};
